export const GameConfig = {
    DESIGN_WIDTH: 750,
    DESIGN_HEIGHT: 1624,
    TOTAL_LEVELS: 100,
    START_COINS: 20350,
    START_ENERGY: 10,
    MAX_ENERGY: 50,
    LEVEL_ENERGY_COST: 0,
    CORRECT_REWARD: 100,
    HINT_COST: 50,
    STORAGE_KEY: "chengyu-hongbao-state-v1",
};

/** The height currently visible on a fixed-width portrait stage, in design units. */
export function visibleDesignHeight(): number {
    const clientWidth = Number(Laya.Browser.clientWidth || globalThis.innerWidth || GameConfig.DESIGN_WIDTH);
    const clientHeight = Number(Laya.Browser.clientHeight || globalThis.innerHeight || GameConfig.DESIGN_HEIGHT);
    if (!clientWidth || !clientHeight) return GameConfig.DESIGN_HEIGHT;
    const height = GameConfig.DESIGN_WIDTH * clientHeight / clientWidth;
    return Math.max(1100, Math.min(GameConfig.DESIGN_HEIGHT, height));
}

export type RouteName = "auth" | "home" | "tasks" | "mine" | "levels" | "quiz" | "wallet" | "rank";
